import type { UpdateModulesOrderReq } from 'types';

type AssistantLabelData = {
  label: string;
  label_En: string;
  label_Sk: string;
  label_Cs: string;
};

export type ModuleAssistantsSummary =
  | {
      kind: 'none';
    }
  | {
      kind: 'single';
      label: string;
    }
  | {
      kind: 'multiple';
      count: number;
      label: string;
    };

const getLocalizedAssistantLabel = (assistant: AssistantLabelData, language: string): string => {
  const normalizedLanguage = language.toLowerCase();

  if (normalizedLanguage.startsWith('cs')) {
    return assistant.label_Cs || assistant.label;
  }

  if (normalizedLanguage.startsWith('sk')) {
    return assistant.label_Sk || assistant.label;
  }

  if (normalizedLanguage.startsWith('en')) {
    return assistant.label_En || assistant.label;
  }

  return assistant.label;
};

export const getModuleAssistantsSummary = (assistants: AssistantLabelData[] | null | undefined, language: string): ModuleAssistantsSummary => {
  if (!assistants || assistants.length === 0) {
    return { kind: 'none' };
  }

  if (assistants.length === 1) {
    return {
      kind: 'single',
      label: getLocalizedAssistantLabel(assistants[0], language),
    };
  }

  return {
    kind: 'multiple',
    count: assistants.length,
    label: assistants.map((assistant) => getLocalizedAssistantLabel(assistant, language)).join(', '),
  };
};

export const createModuleOrderList = (rows: Array<{ id: string }>): UpdateModulesOrderReq['body']['modulOrderList'] => {
  return rows.map((e) => ({
    moduleId: e.id,
    order: rows.indexOf(e) + 1,
  }));
};

export const createUpdateOrderParams = (
  page: number = 1,
  pageSize: number = 10,
  orderBy: string = 'id',
  orderDesc: boolean = false,
  search: string = ''
): UpdateModulesOrderReq['params'] => ({
  Page: page,
  PageSize: pageSize,
  OrderBy: orderBy,
  OrderDesc: orderDesc,
  Search: search,
});

export const createUpdateModuleData = (isFlowModule: boolean, isHeliosModule: boolean, icon: string, pageRowCount: number, parentId?: string) => ({
  isFlowModule,
  isHeliosModule,
  icon,
  pageRowCount,
  ...(parentId && { parentId }),
});

export const updateTableRowIdentifiersWithModuleOrder = <T extends { id: string; identifier?: string }>(
  transformedTableRows: T[],
  originalModuleData: Array<{ id: string; order: number }>
): T[] => {
  transformedTableRows.forEach((transformedRow) => {
    if (transformedRow.identifier) {
      const originalModule = originalModuleData.find((module) => module.id === transformedRow.id);
      transformedRow.identifier = originalModule?.order?.toString() ?? '';
    }
  });

  return transformedTableRows;
};
